import { render, staticRenderFns } from "./VTableHeaders.vue?vue&type=template&id=6e1e467a&scoped=true&"
import script from "./VTableHeaders.vue?vue&type=script&lang=js&"
export * from "./VTableHeaders.vue?vue&type=script&lang=js&"
import style0 from "./VTableHeaders.vue?vue&type=style&index=0&id=6e1e467a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1e467a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
